import { LiveUpdateService } from 'src/providers/live-update-service/live-update.service';
import { PlayerHomeActions } from 'src/redux/player-home/player-home-actions';
import { Preference } from 'src/storage/preference';
import { map } from 'rxjs/operators';
import { filter } from 'rxjs/operators';
import { PlayerHomeDataService } from 'src/redux/player-home/player-home-data-service';
import { PlayerHomeInfo, PlayerInfo } from 'src/data/mygolf.data';
import { GeolocationService } from './../../../providers/geolocation-service/geolocation-service';
import { organizerId } from './../../../globals';
import { Animation } from '@ionic/core';
import { CommonPullupMenuComponent } from 'src/app/pages/modal-screens/common-pullup-menu/common-pullup-menu.component';
import {
  ClubDataLite,
  ClubInfo,
  CountryData,
  DiscountCompany,
  FindTeeTimeCriteria,
  ClubGroup,
  CustomizedAttributes,
} from './../../../data/mygolf.data';
import { distinctUntilChanged, take } from 'rxjs/operators';
import { Router } from '@angular/router';
import { SignUpPage } from './../sign-up/sign-up.page';
import { PlayerHomePage } from './../player-home/player-home.page';
import { MygolfGotoPageHandler } from './../mygolfapp-gotopage-handler';
import { ForgotPasswordPage } from './../forgot-password/forgot-password.page';
import { ConnectionService } from './../../../providers/connection-service/connection-service';
import { MessageDisplayUtil } from './../../../message-display-utils';
import { Component, ViewChild, Input, OnInit, ElementRef } from '@angular/core';
import {
  AbstractControl,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { AppVersion } from '@awesome-cordova-plugins/app-version/ngx';
import { Keyboard } from '@awesome-cordova-plugins/keyboard/ngx';
import { Network } from '@awesome-cordova-plugins/network/ngx';
import {
  AlertController,
  IonApp,
  MenuController,
  ModalController,
  NavController,
  NavParams,
  Platform,
  ToastController,
} from '@ionic/angular';
import { Observable, Subscription, finalize, BehaviorSubject } from 'rxjs';
import { CurrentUser, SessionInfo, SessionState } from './../../../data/authentication-info';
import { ServerInfo } from './../../../data/server-info';
import * as global from 'src/globals';
import { DeviceService } from '../../../providers/device-service/device-service';
import { GotoPageHandlerInterface } from '../../../providers/pushnotification-service/pushnotification-handler';
import { SessionDataService } from '../../../redux/session/session-data-service';
import { isPresent } from 'src/providers/common-service';
import { AuthenticationService } from 'src/authentication-service';
import { SessionActions } from 'src/redux/session';
import { ServerInfoActions } from 'src/redux/server';
import { PushNotificationService } from 'src/providers/pushnotification-service/pushnotification-service';
import { mygolfUtils } from 'src/custom/mygolf2u-utils';
import { ClubFlightService } from '../../../providers/club-flight-service/club-flight-service';
// import { ClubDataLite, ClubInfo, DiscountCompany } from '../../data/mygolf.data';
import * as moment from 'moment';
import { BookingService } from 'src/providers/tee-booking-service/tee-booking-service';
import { CompetitionService } from 'src/providers/competition-service/competition-service';
import { AppCustomizerService } from 'src/providers/app-customizer-service/app-customizer.service';
import { AnimationService } from 'services/animation-service/animation.service';

@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.page.html',
  styleUrls: ['./sign-in.page.scss'],
})
export class SignInPage implements OnInit {
  username: AbstractControl;
  password: AbstractControl;
  displayName: AbstractControl;
  authForm: UntypedFormGroup;
  showLogin: boolean = false;
  state: string = 'initializing';
  initializationError: string;
  serverInfo: ServerInfo;
  showPassword: boolean;
  serverUnreachable: boolean;
  private gotoPageHandler: GotoPageHandlerInterface;
  private sessionStatusSubscription: Subscription;
  retryClicked: boolean = false;
  appAttribute: any;
  @ViewChild('input') myInput;
  webParam: any;
  _timeout;
  appType: string = 'main';
  isDebugMode: boolean;
  logoRadiusParam: string;
  @ViewChild('box') box!: ElementRef<HTMLElement>;
  currentAnim?: Animation;
  constructor(
    private nav: Router,
    private navController: NavController,
    public sessionDataService: SessionDataService,
    private app: IonApp,
    private keyboard: Keyboard,
    private connService: ConnectionService,
    private menu: MenuController,
    private alertCtl: AlertController,
    private toastCtl: ToastController,
    private fb: UntypedFormBuilder,
    private platform: Platform,
    private sessionActions: SessionActions,
    private serverActions: ServerInfoActions,
    private pushService: PushNotificationService,
    private mg2uUtil: mygolfUtils,
    private flightService: ClubFlightService,
    private bookingService: BookingService,
    private compService: CompetitionService,
    private customizerService: AppCustomizerService,
    private modalCtl: ModalController,
    private animation: AnimationService,
    private geoService: GeolocationService,
    private playerHomeService: PlayerHomeDataService,
    private preference: Preference,
    private playerHomeActions: PlayerHomeActions,
    private liveUpdate: LiveUpdateService
  ) {
    this.menu.enable(false);
    this.authForm = this.fb.group({
      username: new UntypedFormControl('', [Validators.required, Validators.minLength(3)]),
      password: new UntypedFormControl('', [Validators.required]),
      displayName: new UntypedFormControl('WAGC Qualifier'),
    });
    this.displayName = this.authForm.controls['displayName'];
    if (global.appClient === 'WAGC') {
      this.displayName.setValue('WAGC');
      this.displayName.patchValue('WAGC');
    } else if (global.appClient?.includes('WAGC-')) {
      this.displayName.setValue('WAGC Qualifier');
      this.displayName.patchValue('WAGC Qualifier');
    } else if (global.appClient?.includes('EPSL')) {
      this.displayName.setValue('EPSL');
      this.displayName.patchValue('EPSL');
    } else if (global.appType === 'main') {
      this.displayName.setValue('myGolf2u');
      this.displayName.patchValue('myGolf2u');
    } else {
      this.displayName.setValue('myGolf2u');
      this.displayName.patchValue('myGolf2u');
    }
    this.username = this.authForm.controls['username'];
    this.password = this.authForm.controls['password'];
    this.gotoPageHandler = new MygolfGotoPageHandler();
    this.appType = global.appType;
    const _param = this.mg2uUtil.getClubId();
    const _logoRadius = this.platform.getQueryParam('logoRadius');
    this.logoRadiusParam = this.platform.getQueryParam('logoRadius');
    if (_logoRadius && _logoRadius === 'false') {
      const clubSignInLogo = document.documentElement.querySelector('.club-sign-in-logo');
      //  .querySelector('.club-sign-in-logo');

      // setProperty('border-radius','0%','important');// .style.setProperty('--new-height','calc(100% - 8em)','important');
      if (clubSignInLogo) {
        clubSignInLogo.setAttribute('border-radius', '0%');
        // clubSignInLogo.style.borderRadius = '0%';
      }
    } else {
      // let clubSignInLogo = el.nativeElement.querySelector('.club-sign-in-logo');
      // if(clubSignInLogo) clubSignInLogo.style.borderRadius = '50%';
      const clubSignInLogo = document.querySelector('.club-sign-in-logo');
      // let clubSignInLogo = document.documentElement.querySelector('.club-sign-in-logo');

      //  .querySelector('.club-sign-in-logo');
      // setProperty('border-radius','0%','important');// .style.setProperty('--new-height','calc(100% - 8em)','important');
      if (clubSignInLogo) {
        clubSignInLogo.setAttribute('border-radius', '50%');
        // clubSignInLogo.style.borderRadius = '0%';
      }
    }
    this.isDebugMode = this.platform.getQueryParam('isDebugMode') === 'true' ? true : false;

    if (_param) {
      this.mg2uUtil.setClubSpecific(true);
      this.mg2uUtil.setClubId(_param);
      this.mg2uUtil.setClubParam(true);
      // window.resizeTo(500, 500);
      // this.appType = 'club';
    } else {
      if (this.appType === 'club' && global.clubId && !global.appClient) {
        this.mg2uUtil.setClubSpecific(true);
        this.mg2uUtil.setClubId(global.clubId);
        this.getClubInfo(global.clubId);
        this.setCompClubId();
      } else if (this.appType === 'club' && global.clubId && global.appClient?.length) {
        // this.mg2uUtil.setClubSpecific(true);
        // this.mg2uUtil.setClubId(global.clubId);
        this.getClubInfo(global.clubId);
        this.setCompClubId(true);
      } else {
        this.mg2uUtil.setClubSpecific(false);
      }
    }

    if (this.mg2uUtil.webPartner && this.mg2uUtil.webPartnerId !== undefined) {
      this.getPartnerAttribute();
    }

    // Prevent duplicate subsidiary processing
    if (this.subsidiaryProcessing) {
      return;
    }

    this.subsidiaryProcessing = true;

    if (this.mg2uUtil.getPref('subsidiaryId')) {
      this.mg2uUtil
        .getPref('subsidiaryId')
        .pipe(take(1))
        .subscribe(id => {
          if (id && id !== null && id !== 'undefined' && id !== undefined) {
            // Only override to 'wagc' if the current id is not already valid
            if (global.appClient === 'WAGC' && !id.startsWith('wagc')) {
              id = 'wagc';
            }

            console.debug('init subsidiary id : ', id, global.appClient);

            // Store the valid subsidiary ID
            this.mg2uUtil.setPref('subsidiaryId', String(id), 'constructor');
            this.subsidiaryId = id;

            this.applySubsidiary(id)
              .then(result => {
                this.subsidiaryProcessing = false;
                if (!result) {
                  MessageDisplayUtil.showErrorToast(
                    'This Country has not been setup in the app',
                    this.platform,
                    this.toastCtl,
                    3000,
                    'bottom'
                  );
                }
              })
              .catch(error => {
                this.subsidiaryProcessing = false;
                console.error('Error applying subsidiary:', error);
              });
          } else if (id === undefined || id === 'undefined') {
            this.subsidiaryProcessing = false;
            this.onPickCountry();
          } else {
            this.subsidiaryProcessing = false;
          }
        });
    }
    if (global.appClient?.length) {
      this.refreshCountryList();
      this.refreshClubGroupList();
      this.getCustomizedAttributes();

      if (this.subsidiaryId === 'epsl') {
        document.body.className = 'theme-' + 'epsl';
      } else {
        document.body.className = '';
      }
    }
    console.debug('this.subsidiaryId', this.subsidiaryId);
  }

  subsidiaryId: string = 'wagc';
  private subsidiaryProcessing: boolean = false;
  private applySubsidiaryPromise: Promise<boolean> | null = null;
  ngOnInit() {
    this.getAppAttribute();
    // let _param = Number(this.platform.getQueryParam('param'));
    // let _hasParam = this.platform.getQueryParam('param');
    if (this.mg2uUtil.getClubParam()) {
      // let selectedClub: ClubInfo;
      const _clubId = this.mg2uUtil.getClubId();
      this.flightService.getClubListLite(_clubId).subscribe(
        (data: any) => {
          this.mg2uUtil.setSelectedClub(data);
          this.mg2uUtil.setClubParam(true);
        },
        error => {},
        () => {
          const _appAttribute = this.mg2uUtil.getSpecificAppAttributePage('playerHome');

          if (_clubId) {
            if (_appAttribute && _appAttribute.clubSpecificThemes) {
              _appAttribute.clubSpecificThemes
                .filter(cc => {
                  return cc.enableTheme && cc.clubId === Number(_clubId);
                })
                .map(cc => {
                  this.updateColor(cc.themeName);
                });
            }
          }
        }
      );
    }
    this.platform.ready().then(() => {
      this.pushService.setControllers(
        this.app,
        this.navController,
        this.alertCtl,
        this.toastCtl,
        this.gotoPageHandler
      );

      // this.onPageInit();

      setTimeout(() => {
        this._init();
        this.webParam = this.mg2uUtil.getClubParam();

        this.getClubSvgFill();
        // if(this.mg2uUtil.getClubSpecific()){
        //   this.getClubSvgFill();
        // } else
        // this.getClubSvgFill();
        // this.myInput.setFocus();
        //this.keyboard.show();
      }, 500);
    });

    this.refreshCountryList();
    this.serverUnreachable = !this.connService.isConnected();
    if (this.platform.is('capacitor')) {
      this.setCurrentVersion();
    }
    // else {
    //   this.currentVersion = '9.9.9';
    // }
  }

  ionViewWillUnload() {
    if (this.sessionStatusSubscription) {
      this.sessionStatusSubscription.unsubscribe();
      this.sessionStatusSubscription = null;
    }
  }
  ionViewDidEnter() {}

  ionViewWillLeave() {
    if (this.platform.is('ios') && this.platform.is('capacitor')) {
      this.keyboard.hide();
    }
  }

  toggleShowPassword(event) {
    this.showPassword = !this.showPassword;
    return false;
  }

  public onPageInit(retry?: boolean) {
    this.retryClicked = retry;
    setTimeout(() => {
      this.retryClicked = false;
    }, 10000);
    this.serverActions.refresh();
  }

  private _init() {
    this.serverActions.refresh();
    this.sessionDataService.showLoginForm().subscribe((show: boolean) => {
      this.showLogin = show;

      if (show) {
        this.sessionDataService.getCurrentUser().subscribe((currUser: CurrentUser) => {
          this.username.setValue(currUser.userName);
        });
      }
    });

    this.sessionDataService.getServerInfo().subscribe((serverInfo: ServerInfo) => {
      //
      this.serverInfo = serverInfo;
      if (this.serverInfo && this.serverInfo.success === false) {
        this._timeout = setTimeout(() => {
          this.onSignout();
          clearTimeout(this._timeout);
        }, 5000);
      } else if (this.serverInfo && this.serverInfo.success === true) {
        clearTimeout(this._timeout);
      }
    });

    this.sessionStatusSubscription = this.sessionDataService
      .getSessionStatus()
      .pipe(distinctUntilChanged())
      .subscribe((status: SessionState) => {
        //
        this.sessionDataService
          .getSession()
          .pipe(take(1))
          .subscribe(
            async (session: SessionInfo) => {
              //
              if (status === SessionState.LoginFailed) {
                // second show toast - wrong password enter
                const toast = await this.toastCtl.create({
                  message: session.exception,
                  duration: 5000,
                  buttons: [
                    {
                      text: 'cancel',
                      role: 'cancel',
                      handler: () => {},
                    },
                  ],
                });
                toast.present().then(() => {
                  this.sessionActions.clearLoginError();
                });
                MessageDisplayUtil.showErrorToast(
                  session.exception,
                  this.platform,
                  this.toastCtl,
                  5000,
                  'bottom'
                );
              } else if (status === SessionState.LoggedIn) {
                this.playerHomeActions.refreshForcefully();
                // this.playerHomeInfo$ = this.playerHomeService.playerHomeInfo();

                // const playerSubject = new BehaviorSubject<PlayerInfo | null>(null);
                // this.player$ = playerSubject.asObservable();

                // this.preference
                //   .getPref('cachedPlayerData')
                //   .subscribe((cachedPlayer: PlayerInfo) => {
                //     if (cachedPlayer) {
                //       console.debug('[ngOnInit] Loaded cached player data:', cachedPlayer);
                //       playerSubject.next(cachedPlayer);
                //     }
                //   });
                // this.playerHomeInfo$
                //   .pipe(
                //     filter(Boolean),
                //     map((playerHome: PlayerHomeInfo) => playerHome.player)
                //   )
                //   .subscribe((player: PlayerInfo) => {
                //     console.debug('[player$] Live player data received:', player);
                //     // playerSubject.next(player);
                //     // this.playerInfo = player;
                //     this.preference.setPref('cachedPlayerData', player).subscribe();
                //   });
                if (session && !session.password) {
                  this.onSignout();
                } else {
                  this.mainPage(session);
                }
                if (this._timeout) {
                  clearTimeout(this._timeout);
                }
              } else if (status === SessionState.LoggedOut) {
                this.onSignout();
              } else {
                if (session && session.password) {
                  if (session && session.userName) {
                    this.username.setValue(session.userName);
                  }
                  this.password.setValue(session.password);
                  if (this.authForm.value.username && this.authForm.value.password) {
                    this.signin();
                  }
                } else {
                  this.onSignout();
                }
              }
            },
            error => {}
          );
      });

    // if (this.showLogin)
    this.detectCountry();
  }

  public playerHomeInfo$: Observable<PlayerHomeInfo>;
  public player$: Observable<PlayerInfo>;
  async mainPage(session?: SessionInfo) {
    this.menu.enable(true);
    // session = this.auth.currentSession();
    if (this.platform.is('ios') && this.platform.is('capacitor')) {
      this.keyboard.hide();
    }
    //
    if (isPresent(session)) {
      console.debug(
        'mainPage() ',
        Number(this.mg2uUtil.getClubId()),
        session,
        global,
        this.appType
      );
      if (session.userType === 'Player') {
        if (session.user && session.user.partnerId) {
          this.checkAndSetPartnerType(session.user.partnerId);
        } else {
          this.mg2uUtil.setUserType(null);
        }
        const _hasParam = Number(this.mg2uUtil.getClubId());
        if (_hasParam && this.appType === 'main') {
          let selectedClub: ClubInfo;
          const _clubId = _hasParam;
          this.flightService
            // .getClubListLite(_clubId)
            .getClubInfo(_clubId)
            .subscribe(async (data: ClubDataLite) => {
              console.debug(
                'mainPage() 000',
                Number(this.mg2uUtil.getClubId()),
                session,
                global,
                this.appType
              );
              this.mg2uUtil.setSelectedClub(data);
              this.mg2uUtil.setClubParam(true);
              this.nav.navigate(['/tabs/player-home'], { replaceUrl: true });
              setTimeout(() => {
                // queryParams: { param: 310510379 },
                // this.nav.navigate(['booking-home'], {
                if (this.appType === 'main') {
                  this.nav.navigate(['find-tee-times'], {
                    state: {
                      userType: 'player',
                      isClubSpecific: true,
                      club: data,
                      clubSpecificThemes:
                        this.appAttribute && this.appAttribute.clubSpecificThemes
                          ? this.appAttribute.clubSpecificThemes
                          : null,
                    },
                  });
                }
              }, 1500);
            });
        } else {
          console.debug(
            'mainPage() 11 ',
            Number(this.mg2uUtil.getClubId()),
            session,
            global,
            this.appType
          );
          if (this.appType === 'main') {
            this.nav.navigate(['/tabs/player-home'], { replaceUrl: true });
          } else if (
            (this.appType === 'specific' || this.appType === 'club') &&
            (global.appClient === 'WAGC' || global.appClient?.includes('WAGC-'))
          ) {
            //! to add customized service redirection page here
            console.debug('wagc specific app', global.appClient, global.appType);
            this.customizerService.goToPlayerHome();
            // this.nav.navigate(['/tabs/wagc-player-home'], { replaceUrl: true });
          } else if (global?.appClient?.length) {
            this.nav.navigate([`/tabs/${global?.appClient?.toLowerCase()}-player-home`], {
              replaceUrl: true,
            });
          } else {
            this.nav.navigate(['/tabs/player-home'], { replaceUrl: true });
          }
        }
      } else if (session.userType === 'Club') {
        // this.nav.setRoot(ClubHomePage);
      }
    } else {
    }
  }

  checkAndSetPartnerType(partnerId: string) {
    this.flightService.getPartnerDetails(partnerId).subscribe((data: any) => {
      if (data) {
        if (data.partnerServices) {
          data.partnerServices
            .filter(service => {
              return service.toLowerCase().includes('booking_agent');
            })
            .map(service => {
              this.mg2uUtil.setUserType('booking_agent');
              this.mg2uUtil.setPartnerInfo(data);
            });
        }
      }
      // this.mg2uUtil.setUserType
    });
  }

  public signin() {
    // setTimeout(()=>{
    if (!this.authForm.value.username || !this.authForm.value.password) {
      const subTitle = 'Please enter email and password';
      MessageDisplayUtil.showErrorToast(subTitle, this.platform, this.toastCtl, 3000, 'bottom');
      if (this.platform.is('ios') && this.platform.is('capacitor')) {
        this.keyboard.hide();
      }
      return false;
    }
    if (global.appClient === 'WAGC-QLFR') {
      console.debug('subsidiary', global.appClient, this.subsidiaryId, this.customizedAttributes);
      if (
        this.subsidiaryId &&
        (!this.customizedAttributes?.organizerId ||
          this.customizedAttributes?.organizerId === undefined)
      ) {
        MessageDisplayUtil.showErrorToast(
          'This Country has not been setup in the app',
          this.platform,
          this.toastCtl,
          3000,
          'bottom'
        );
        return;
      }
      this.mg2uUtil.getPref('subsidiaryId').subscribe(id => {
        console.debug('signing in : ', id);
        if (!id || id === 'wagc') {
          this.onSelectSubsidiary().then((result: any) => {
            if (result) {
              if (this._timeout) {
                clearTimeout(this._timeout);
              }
              const clubId = this.customizedAttributes?.clubId;
              const loginMembersOnly = this.customizedAttributes?.loginMembersOnly;
              this.sessionActions.login(
                this.authForm.value.username,
                this.authForm.value.password,
                'play',
                {
                  clubId,
                  loginMembersOnly,
                }
              );
            }
          });
        } else {
          if (this._timeout) {
            clearTimeout(this._timeout);
          }
          const clubId = this.customizedAttributes?.clubId;
          const loginMembersOnly = this.customizedAttributes?.loginMembersOnly;
          const params = {
            clubId,
            loginMembersOnly,
          };
          this.sessionActions.login(
            this.authForm.value.username,
            this.authForm.value.password,
            'play',
            {
              clubId,
              loginMembersOnly,
            }
          );
        }
        return;
      });

      return;
    } else if (global.appClient === 'WAGC') {
      this.applySubsidiary('wagc').then(result => {
        if (result) {
          if (this._timeout) {
            clearTimeout(this._timeout);
          }
          const clubId = this.customizedAttributes?.clubId;
          const loginMembersOnly = this.customizedAttributes?.loginMembersOnly;
          const params = {
            clubId,
            loginMembersOnly,
          };
          this.sessionActions.login(
            this.authForm.value.username,
            this.authForm.value.password,
            'play',
            params
          );
        } else {
          MessageDisplayUtil.showErrorToast(
            'This Country has not been setup in the app',
            this.platform,
            this.toastCtl,
            3000,
            'bottom'
          );
        }
      });
    } else if (global.appClient === 'EPSL') {
      this.applySubsidiary('epsl').then(result => {
        if (result) {
          if (this._timeout) {
            clearTimeout(this._timeout);
          }
          const clubId = this.customizedAttributes?.clubId;
          const loginMembersOnly = this.customizedAttributes?.loginMembersOnly;
          const params = {
            clubId,
            loginMembersOnly,
          };
          this.sessionActions.login(
            this.authForm.value.username,
            this.authForm.value.password,
            'play',
            params
          );
        } else {
          MessageDisplayUtil.showErrorToast(
            'This Country has not been setup in the app',
            this.platform,
            this.toastCtl,
            3000,
            'bottom'
          );
        }
      });
    } else {
      this.mg2uUtil.setPref('subsidiaryId', null, 'main app');
      if (this._timeout) {
        clearTimeout(this._timeout);
      }
      this.sessionActions.login(this.authForm.value.username, this.authForm.value.password, 'play');
    }
  }

  signup() {
    if (this.appType === 'club' && global.appClient?.includes('WAGC-')) {
      this.onSelectSubsidiary().then((result: any) => {
        this.nav.navigate(['wagc-qlfr-sign-up'], { replaceUrl: true });
      });
      return;
    }

    if (this.appType === 'specific' || this.appType === 'club') {
      if (global.appClient?.includes('WAGC-')) {
        this.nav.navigate(['wagc-qlfr-sign-up'], { replaceUrl: true });
      } else if (global.appClient === 'WAGC') {
        this.nav.navigate(['wagc-sign-up'], { replaceUrl: true });
      }
      //! to add customized service redirection page here
      else {
        this.nav.navigate(['wagc-sign-up'], { replaceUrl: true });
      }
    } else {
      this.nav.navigate(['sign-up']);
    }

    // this.nav.push(SignUp);
  }

  forgotPassword() {
    this.nav.navigate(['forgot-password']);
  }
  exitApp() {
    // navigator['app'].exitApp();
  }

  isCordova() {
    return this.platform.is('capacitor');
  }

  onSignout() {
    this.sessionActions.logout();
  }

  getClubLogo(type?: string) {
    if (global.appType === 'club' && global.clubId === 310510386) {
      return 'assets/img/club-logo/minesLogo.png';
    } else if (global.appType === 'club') {
      if (global.appClient?.length && global.appClient?.includes('WAGC-')) {
        if (this.subsidiaryId?.includes('wagc-')) {
          return `assets/customized/club/${this.subsidiaryId}/logo.png`;
        } else if (this.customizedAttributes?.signInLogo) {
          return this.customizedAttributes?.signInLogo;
        } else if (this.selectedClubGroup) {
          return this.selectedClubGroup?.clubLogo;
        } else {
          return `assets/customized/club/wagc/logo.png`;
        }
      } else if (global.appClient?.length && global.appClient === 'WAGC') {
        return `assets/customized/club/${global.appClient?.toLowerCase()}/logo.png`;
      } else {
        return this.mg2uUtil.getClubLogo('logo');
      }
    } else if (
      global.appType === 'main' &&
      global.clubId === null &&
      this.mg2uUtil.getClubParam()
    ) {
      //
      return this.mg2uUtil.getClubSpecificHeader('header-logo'); //.getClubLogo('logo');
    } else if (type === 'header' && this.getPartnerSignInLogo()) {
      return this.getPartnerSignInLogo();
    } else if (type === 'header') {
      return 'assets/img/main-round-logo.svg';
    } else {
      return 'assets/img/mg2u-circle-512.png';
    }
  }

  getAppAttribute() {
    this.flightService.getAppAttributes().subscribe((data: any) => {
      //
      if (data) {
        this.mg2uUtil.setAppAttributes(data);
        data
          .filter(d => {
            return d.page === 'playerHome';
          })
          .map(d => {
            this.appAttribute = d;
          });
        //
        if (this.appAttribute) {
          if (this.appAttribute.maintenance) {
            // this.displayMaintenance(this.appAttribute);
          }
          if (global.appType === 'club' && global.clubId && global.clubId === 310510386) {
            this.updateColor('gold');
          }
          // if (this.appAttribute.announcement) {
          //     this.displayAnnouncement(this.appAttribute);
          // }
        }
      }
    });
  }

  getPartnerAttribute() {
    this.flightService.getPartnerAttributes().subscribe((data: any) => {
      // console.debug("get partner attributes ", data)
      if (data) {
        this.mg2uUtil.setPartnerAttributes(data);
      }
    });
  }

  async displayMaintenance(appAttribute) {
    if (!appAttribute) {
      return false;
    }
    const _maintenance = appAttribute.maintenance;
    const _fromDate = _maintenance.fromDate;
    const _daysBefore = _maintenance.daysBefore;
    let _dateBefore;
    if (_daysBefore) {
      _dateBefore = moment(_fromDate).add(-1 * _daysBefore, 'days');
    }
    const _toDate = _maintenance.toDate;
    // if(_daysBefore) _dateBefore = moment(_toDate).add(-1*_daysBefore, "days");
    const _fromTime = _maintenance.fromTime;
    const _toTime = _maintenance.toTime;

    const _fromDateTime = moment(_fromDate + _fromTime, 'YYYY-MM-DDHH:mm');
    // moment(_dateBefore).format("YYYY-MM-DD")

    const _toDateTime = moment(_toDate + _toTime, 'YYYY-MM-DDHH:mm');
    //
    //
    //
    //
    //
    //
    if (_maintenance.showMaintenanceMessage) {
      // let _msg = "Server is currently under maintenance. <br>Scheduled time <br><b>"+moment(_fromDateTime).format("ddd, DD MMM YYYY HH:mm") + "</b> to <b>" + moment(_toDateTime).format("ddd, DD MMM YYYY HH:mm")+"</b>";
      let _msg =
        'The system will be unavailable during the following period : <br><b>' +
        moment(_fromDateTime).format('ddd, DD MMM YYYY HH:mm') +
        '</b> to <br><b>' +
        moment(_toDateTime).format('ddd, DD MMM YYYY HH:mm') +
        '</b>';
      if (_maintenance.maintenanceMessage) {
        _msg =
          _maintenance.maintenanceMessage +
          '<br><b>' +
          moment(_fromDateTime).format('ddd, DD MMM YYYY HH:mm') +
          '</b> to <br><b>' +
          moment(_toDateTime).format('ddd, DD MMM YYYY HH:mm') +
          '</b>';
      }
      const _buttons = [];
      if (
        _maintenance.blockForMaintenance &&
        moment().isBetween(_fromDateTime, _toDateTime, 'minute')
      ) {
        if (this.platform.is('cordova')) {
          _buttons.push({
            text: 'Close',
            role: 'cancel',
            handler: () => {
              if (this.platform.is('cordova')) {
                _alert.dismiss(true);
              }
              return false;
            },
          });
        }
      } else {
        _buttons.push({
          text: 'Okay',
          role: 'cancel',
          handler: () => {
            _alert.dismiss(false);
            return false;
          },
        });
      }
      const _alert = await this.alertCtl.create({
        header: 'Server Maintenance',
        message: _msg,
        buttons: _buttons,
        backdropDismiss: _maintenance.blockForMaintenance ? false : true,
      });
      _alert.onDidDismiss().then((exit: any) => {
        // if (exit) this.platform.exitApp();
      });
      // if(moment().isBetween(_fromDate + " " + _fromTime, _toDate + " " + _toTime ))
      //
      //
      //
      // if(moment().isBetween(_fromDateTime, _toDateTime,'minute') ||  moment().isBetween(_dateBefore,moment(_toDate,"YYYY-MM-DD")))
      if (moment().isBetween(_dateBefore, _toDateTime, 'minute')) {
        _alert.present();
      }
      // .endOf('day')
    }
  }

  updateColor(themeName?: string, reset?: boolean) {
    // document.documentElement.style.setProperty(`--color`, color);
    //
    if (themeName) {
      document.body.className = 'theme-' + themeName;
    } else {
      document.body.className = '';
    }
    // .toggle(color);
    // document.documentElement.style.setProperty(`--ion-border-color`, color);
  }

  getClubBanner() {
    if (global.appType === 'club' && global.clubId === 310510386) {
      if (this.mg2uUtil.getClubLogo('banner')) {
        return this.mg2uUtil.getClubLogo('banner');
      } else {
        return global.MygolfServer + '/document/assets/clubSpecific/banner/minesBanner.png';
      }
    } else if (global.appType === 'club') {
      if (this.mg2uUtil.getClubLogo('banner')) {
        return this.mg2uUtil.getClubLogo('banner');
      } else {
        return 'assets/img/mg2u-circle-512.png';
      }
    } else {
      return 'assets/img/mg2u-circle-512.png';
    } //'assets/img/New-myGolf2u.png';//
  }

  canSignUp() {
    // if(this.appType !== 'main') return;
    // console.debug(
    //   'can sign up : ',
    //   this.appType,
    //   global.appType,
    //   global.membersOnly,
    //   this.customizedAttributes,
    //   this.subsidiaryId
    // );
    if (global.appType === 'club' && global.membersOnly) {
      return false;
    } else if (global.appType === 'club' && global?.appClient?.length && !global.membersOnly) {
      if (
        isPresent(this.customizedAttributes) &&
        (!this.customizedAttributes.organizerId ||
          !this.customizedAttributes.organizerId === null ||
          !this.customizedAttributes.organizerId === undefined)
      ) {
        return false;
      } else {
        return true;
      }
    }
    const _appAttribute = this.mg2uUtil.getSpecificAppAttributePage('mainApp');
    let _enableSignUp = [];

    if (_appAttribute && _appAttribute.clubEnablePlayerSignUp) {
      _enableSignUp = _appAttribute.clubEnablePlayerSignUp.filter(clubId => {
        return clubId === global.clubId;
      });
    }

    return _enableSignUp && _enableSignUp.length > 0 && !this.isCordova();
  }

  getClassSignInLogo() {
    if (global.appType === 'club' && global.clubId === 310510386) {
      if (this.mg2uUtil.getClubLogo('banner')) {
        return 'sign-in-logo';
      } else {
        return 'sign-in-logo';
      }
    } else if (
      global.appType === 'main' &&
      global.clubId === null &&
      this.mg2uUtil.getClubParam()
    ) {
      if (this.logoRadiusParam === 'true') {
        return 'club-sign-in-logo logo-radius-50';
      } else if (this.logoRadiusParam === 'false') {
        return 'club-sign-in-logo no-logo-radius';
      } else {
        return 'club-sign-in-logo logo-radius-50';
      }
    } else {
      return 'sign-in-logo';
    }
  }

  getClassSignInBackground() {
    if (global.appType === 'club' && global.clubId === 310510386) {
      if (this.mg2uUtil.getClubLogo('banner')) {
        return '';
      } else {
        return '';
      }
    } else if (global.appType === 'club') {
      return '';
    } else if (
      global.appType === 'main' &&
      global.clubId === null &&
      this.mg2uUtil.getClubParam()
    ) {
      return 'club-sign-in-background';
    } else {
      return 'mygolf-special-page-background';
    }
  }

  debugMode(attribute: string) {
    switch (attribute) {
      case 'splash':
        return this.isDebugMode;
      case 'sign-in':
        return !this.isDebugMode;
    }
  }

  getSignInBg() {
    if ((this.mg2uUtil.webPartner && this.mg2uUtil.webPartnerId, this.mg2uUtil.partnerAttributes)) {
      const _partnerId = this.mg2uUtil.webPartnerId;
      const _partnerThemes = this.mg2uUtil.partnerAttributes?.partnerSpecificThemes;
      let _theme;
      console.debug('sign in bg ', this.mg2uUtil.partnerAttributes, _partnerThemes, _partnerId);
      if (_partnerThemes && _partnerThemes.length > 0) {
        _partnerThemes
          .filter(t => {
            return t.partnerId === _partnerId;
          })
          .map(t => {
            _theme = t;
          });
      }
      console.debug('sign in bg [2] ', _theme);
      if (_theme) {
        return global.MygolfServer + '/' + _theme?.signInBg;
      } else {
        return '../../../assets/img/loginBg.png';
      }
    } else {
      return '../../../assets/img/loginBg.png';
    }
  }

  getPartnerSignInLogo() {
    if ((this.mg2uUtil.webPartner && this.mg2uUtil.webPartnerId, this.mg2uUtil.partnerAttributes)) {
      const _partnerId = this.mg2uUtil.webPartnerId;
      const _partnerThemes = this.mg2uUtil.partnerAttributes?.partnerSpecificThemes;
      let _theme;
      // console.debug("sign in bg ", this.mg2uUtil.partnerAttributes, _partnerThemes, _partnerId);
      if (_partnerThemes && _partnerThemes.length > 0) {
        _partnerThemes
          .filter(t => {
            return t.partnerId === _partnerId;
          })
          .map(t => {
            _theme = t;
          });
      }
      // console.debug("sign in bg [2] ", _theme);
      if (_theme) {
        return global.MygolfServer + '/' + _theme?.signInLogo;
      } else {
        return 'assets/img/main-round-logo.svg';
      }
    }
  }

  isMobileLayout() {
    return this.mg2uUtil.isMobileLayout();
  }

  onClickContactUs() {
    this.nav.navigate(['contact-us']);
  }

  selectedClub: ClubInfo;
  getClubInfo(clubId) {
    const _bookingSearchCriteria: FindTeeTimeCriteria = this.bookingService.getSearch();
    const _clubId = clubId;
    const clubInfo = this.flightService.getClubInfo(_clubId).subscribe(
      (data: ClubInfo) => {
        this.selectedClub = data;
        _bookingSearchCriteria.clubId = _clubId;
        _bookingSearchCriteria.clubInfo = data;
      },
      error => {},
      () => {
        this.bookingService.setSearch(_bookingSearchCriteria);
      }
    );
    return clubInfo;
  }

  async setCompClubId(clear?: boolean) {
    const _clubId = global.clubId || this.selectedClub?.clubId || this.selectedClub?.id;
    const searchCriteriaComp = this.compService.getSearch();
    if (clear) {
      searchCriteriaComp.clubId = null;
      this.mg2uUtil.setPersistClubTheme();
      this.compService.setSearch(searchCriteriaComp);
    }
    if (clear) {
      searchCriteriaComp.clubId = null;
    } else {
      searchCriteriaComp.clubId = _clubId;
      searchCriteriaComp.clubTypes = 'Specific';
    }
    if (clear) {
      this.mg2uUtil.setPersistClubTheme();
    } else {
      this.mg2uUtil.setPersistClubTheme(String(_clubId));
    }
    this.compService.setSearch(searchCriteriaComp);
  }

  svgFillClass: string = 'fill-white';
  getClubSvgFill() {
    if (global.appType === 'main') {
      this.svgFillClass = 'fill-white';
    } else if (global.appType === 'club' && global.appClient?.length) {
      this.svgFillClass = 'fill-white';
    } else {
      this.svgFillClass = 'fill-theme';
    } // or 'fill-gold', 'fill-dark' dynamically
  }

  // displayName: string = 'WAGC Qualifier';
  getSubtextAppName() {
    if (global.appType === 'main') {
      return 'myGolf2u';
    } else if (global.appType === 'club' && global.appClient?.length) {
      if (global.appClient === 'WAGC') {
        return global.appClient;
      } else if (global.appClient?.includes('WAGC-')) {
        let _displayName = 'WAGC Qualifier';
        if (this.customizedAttributes?.displayName?.length) {
          _displayName = this.customizedAttributes?.displayName;
        }
        return _displayName;
      }
      return global.appClient;
    } else {
      return 'myGolf2u';
    }
  }

  getAppClient() {
    return global.appClient;
  }

  onPickCountry() {
    console.debug('club group list ', this.clubGroupList);
    if (!this.clubGroupList?.length || !this.clubGroupList) {
      Promise.all([this.refreshClubGroupList]).then(() => {
        this.onSelectSubsidiary().then(() => {});
      });
    } else {
      this.onSelectSubsidiary().then(() => {});
    }
  }

  selectedClubGroup;
  clubGroupList: Array<any>; //ClubGroup;
  refreshClubGroupList() {
    if (!global.appClient?.length) {
      return;
    }
    if (!global.appClient.includes('WAGC')) {
      return;
    }
    const _clubGroup = 'WAGC';
    this.flightService.getClubsUnderClubGroup(_clubGroup).subscribe(data => {
      this.clubGroupList = data;
    });
  }

  async onSelectSubsidiary() {
    return new Promise(async (resolve, reject) => {
      let _allCustAttr;
      let _dataList = [
        // {
        //   id: 'wagc-my-pnags',
        //   shortName: 'wagc-my-pnags',
        //   name: 'Malaysia PNAGS',
        //   iconUrl: 'assets/img/MAS.png',
        //   data: {},
        // },
        // {
        //   id: 'wagc-ph',
        //   shortName: 'wagc-ph',
        //   name: 'Phillipines',
        //   iconUrl: 'assets/icons/PHI.png',
        //   data: {},
        // },
        // {
        //   id: 'epsl',
        //   name: 'European Players Super League',
        //   iconUrl: 'assets/icons/book.png',
        // },
      ];

      let localClubGroupList = this.appAttribute?.localClubGroupList;
      if (!this.appAttribute.localClubGroupList) {
        localClubGroupList = [
          {
            id: 'WAGC_MYS',
            name: 'Malaysia PNAGS',
            shortName: '[MYS] WAGC',
            iconUrl: '',
          },
        ];
      }

      const useLocalClubGroupList = this.appAttribute?.useLocalClubGroupList;
      if (useLocalClubGroupList) {
        localClubGroupList.forEach(club => {
          _dataList.push({
            id: club?.id,
            name: club?.name,
            shortName: club?.shortName,
            iconUrl: club?.country?.flagUrl || this.getCountryFlag(club?.country?.id),
            data: club,
          });
        });
      } else {
        if (this.clubGroupList?.length) {
          // _dataList = [];
          this.clubGroupList.forEach(club => {
            _dataList.push({
              id: club?.tag,
              name: club?.displayName || club?.name,
              shortName: club?.clubName,
              iconUrl: club?.country?.flagUrl || this.getCountryFlag(club?.country?.id),
              data: club,
            });
          });
        }
      }
      console.debug('attr list : ', _dataList, this.appAttribute);
      this.customizerService.getAllCustomizedAttributes().subscribe(list => {
        console.debug('attr list : ', list, _dataList);
        _dataList = _dataList.filter(qlfyClub =>
          list.some(custAttr => custAttr.subsidiary === qlfyClub.id && !custAttr.subsidiaryDisable)
        );
      });
      const modal = await this.modalCtl.create({
        mode: 'ios',
        component: CommonPullupMenuComponent,
        cssClass: 'self-adjustable-modal',
        componentProps: {
          app: null,
          dataList: _dataList,
          mode: 'common',
          headerTitle: 'Select Qualifying Country',
        },
      });
      await modal.present().then(() => {
        const height = this.platform.height() - 250;
        document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
      });
      modal.onDidDismiss().then((data: any) => {
        console.debug('pullup dismiss', data, this.clubGroupList);
        if (data) {
          const selectedId = data?.data?.id;
          if (selectedId) {
            this.selectedClubGroup = null;
            if (useLocalClubGroupList) {
              this.selectedClubGroup = localClubGroupList.find(club => club?.id === selectedId);
              this.customizerService.setOrganizerId(this.selectedClubGroup.organizerId);
            } else {
              this.selectedClubGroup = this.clubGroupList.find(club => club?.tag === selectedId);
              this.customizerService.setCompWAGCCountry(this.selectedClubGroup);
            }

            this.applySubsidiary(selectedId).then((result: boolean) => {
              if (result) {
                resolve(true);
              } else {
                this.selectedClubGroup = null;
                resolve(false);
                MessageDisplayUtil.showErrorToast(
                  'This Country has not been setup in the app',
                  this.platform,
                  this.toastCtl,
                  3000,
                  'bottom'
                );
              }
            });
          }
        }
      });
    });
  }

  subCustAttribute: Subscription;
  customizedAttributes: CustomizedAttributes;
  getCustomizedAttributes() {
    this.customizerService.getCustomizedAttributes().subscribe(data => {
      if (data) {
        this.customizedAttributes = data;
      }
    });
  }
  async setCompOrganizerId(clear?: boolean, _organizerId?: number) {
    const searchCriteriaComp = this.compService.getSearch();
    const organizerId = global.organizerId;
    if (clear) {
      searchCriteriaComp.organizerId = null;
    } else if (_organizerId) {
      searchCriteriaComp.organizerId = _organizerId;
    } else {
      searchCriteriaComp.organizerId = organizerId;
    } // appClubId || this.selClubMembership?.club?.clubId;
    if (global?.clubId && global?.organizerId) {
      searchCriteriaComp.clubId = null;
    }
    console.debug('setting comp organizer id ', searchCriteriaComp, _organizerId);
    this.compService.setSearch(searchCriteriaComp);
  }

  async setCompPartOfLeague(partOfLeague: 'Y' | 'N' | 'B', clear?: boolean) {
    const searchCriteriaComp = this.compService.getSearch();
    if (clear) {
      searchCriteriaComp.partOfLeague = null;
    } else {
      searchCriteriaComp.partOfLeague = partOfLeague;
    } // appClubId || this.selClubMembership?.club?.clubId;
    this.compService.setSearch(searchCriteriaComp);
  }

  getShapeContentClass() {
    if (global.appClient === 'WAGC-QLFR') {
      return 'wagc-qlfr';
    } else {
      return '';
    }
  }

  getSubsidiaryFlag() {
    if (this.subsidiaryId === 'wagc' || this.subsidiaryId === null) {
      return 'assets/customized/club/wagc/logo.png';
    } else {
      return this.getSelectedClub('countryFlag');
    }
    // else return `assets/customized/club/${this.subsidiaryId}/logo.png`;
  }

  applySubsidiary(subsidiaryId: string) {
    // Prevent duplicate calls and race conditions
    if (this.applySubsidiaryPromise) {
      return this.applySubsidiaryPromise;
    }

    if (!isPresent(subsidiaryId)) {
      return;
    }
    this.applySubsidiaryPromise = new Promise((resolve, reject) => {
      // this.animation.fadeSlide(this.box.nativeElement);
      this.startThrobbing();
      Promise.all([
        this.customizerService.onSetSubsidiary(subsidiaryId, 'sign in - apply subsidiary'),
        this.customizerService.refreshCustomizedAttributes(),
      ])
        .then(result => {
          if (result[0]) {
            console.debug('[0] after customizedAttributes', result);

            // Use take(1) to ensure only one emission and auto-unsubscribe
            this.customizerService
              .getCustomizedAttributes()
              .pipe(
                take(1),
                finalize(() => {
                  setTimeout(() => {
                    this.stopThrobbing();
                  }, 700);

                  console.debug(
                    'after customizedAttributes',
                    subsidiaryId,
                    this.customizedAttributes,
                    this.customizedAttributes?.organizerId
                  );

                  // Reset promise after completion
                  this.applySubsidiaryPromise = null;
                })
              )
              .subscribe({
                next: data => {
                  if (data) {
                    this.customizedAttributes = data;
                  }

                  console.debug(
                    'before customizedAttributes',
                    data,
                    subsidiaryId,
                    this.customizedAttributes?.organizerId,
                    this.customizedAttributes,
                    data
                  );

                  // Check if we have valid customized attributes
                  if (
                    this.customizedAttributes === undefined ||
                    this.customizedAttributes?.organizerId === null ||
                    this.customizedAttributes?.organizerId === undefined
                  ) {
                    resolve(false);
                  } else {
                    // Use take(1) to prevent multiple organizerId calls
                    this.customizerService
                      .getOrganizerId()
                      .pipe(take(1))
                      .subscribe(orgId => {
                        console.debug(
                          'applying subsidiary : ',
                          orgId,
                          subsidiaryId,
                          this.subsidiaryId
                        );

                        // Only update if we have valid data
                        if (orgId && orgId > 0) {
                          this.mg2uUtil.setPref('subsidiaryId', String(subsidiaryId), 'apply sub');
                          this.subsidiaryId = subsidiaryId;

                          // Update display name only if we have valid data
                          const displayName =
                            this.getSelectedClub('displayName') ||
                            this.customizedAttributes?.displayName;
                          if (displayName) {
                            this.displayName.setValue(displayName);
                            this.displayName.patchValue(displayName);
                            this.displayName.updateValueAndValidity();
                          }

                          this.setCompPartOfLeague('B');
                          this.setCompOrganizerId(null, orgId);
                          this.setCompClubId(true);
                          resolve(true);
                        } else {
                          resolve(false);
                        }
                      });
                  }
                },
                error: error => {
                  console.error('Error in applySubsidiary:', error);
                  setTimeout(() => {
                    this.stopThrobbing();
                  }, 2000);
                  this.applySubsidiaryPromise = null;
                  resolve(false);
                },
              });
          } else {
            this.applySubsidiaryPromise = null;
            resolve(false);
          }
        })
        .catch(error => {
          console.error('Error in applySubsidiary Promise.all:', error);
          this.stopThrobbing();
          this.applySubsidiaryPromise = null;
          resolve(false);
        });
    });

    return this.applySubsidiaryPromise;
  }

  startThrobbing() {
    if (1) {
      return;
    }
    if (!this.box) {
      return;
    }
    if (!this.box?.nativeElement) {
      return;
    }
    this.currentAnim = this.animation.throbbingFade(this.box.nativeElement, {
      duration: 700, //700,
      scale: 1,
      // iterations: 1,
    });
  }

  stopThrobbing() {
    if (this.currentAnim) {
      this.currentAnim.stop();
      this.currentAnim = undefined;
    }
  }

  countryList: Array<CountryData> = new Array<CountryData>();

  refreshCountryList() {
    this.customizerService.getCountryList().subscribe((countryList: Array<CountryData>) => {
      this.countryList = countryList;
    });
  }

  getCountryFlag(countryId: string) {
    let countryFlag = 'assets/customized/club/wagc/flag.png';
    if (!countryId || countryId == undefined) {
      return countryFlag;
    }
    if (!this.countryList) {
      return countryFlag;
    }
    if (this.countryList?.length) {
      countryFlag = this.countryList.find(country => country.id === countryId)?.flagUrl;
    }
    return countryFlag;
    // else return countryFlag;
  }

  getSelectedClub(attribute: string) {
    const selectedClub = this.selectedClubGroup;
    //  this.clubGroupList?.find(club => {
    //   return club?.tag === this.subsidiaryId;
    // });
    switch (attribute) {
      case 'displayName':
        return selectedClub?.displayName;
      case 'countryFlag':
        if (selectedClub) {
          return selectedClub?.country?.flagUrl;
        } else {
          return 'assets/customized/club/wagc/logo.png';
        }
    }
  }

  async detectCountry() {
    let countryId;
    // const position = await this.geoService.getNewCurrentPosition();
    // const lat = position.coords.latitude;
    // const lng = position.coords.longitude;
    // console.debug('detect country [0] : ', country, lat, lng, position);
    // let oldPosition;
    // let oldlat; // = position.coords.latitude;
    // let oldlng; // = oldPosition.coords.longitude;
    // this.geoService.getCurrentPosition().subscribe(coord => {
    //   oldlat = coord.coords.latitude;
    //   oldlng = coord.coords.longitude;
    // });

    // console.debug('detect country [00] : ', country, oldlat, oldlng, oldPosition);

    this.geoService.getGeoLocation().subscribe(coords => {
      // country = await this.geoService.getCountryFromCoordinates(lat, lng);
      countryId = coords.countryId;

      if (global.appClient.includes('WAGC-')) {
        let _subsidiaryId = '';
        this.mg2uUtil.getPref('subsidiaryId').subscribe(id => {
          _subsidiaryId = id;
          console.debug('apply subsidiary by country : ', _subsidiaryId, id);
        });
        if (_subsidiaryId === '' || _subsidiaryId === 'wagc' || _subsidiaryId === undefined) {
          const selectedClub = this.clubGroupList?.find(club => {
            return club?.country?.iso2Code === countryId;
          });
          this.selectedClubGroup = selectedClub;
          this.applySubsidiary(selectedClub?.tag).then(() => {});
        }
      }
      // console.debug('detect country : ', country, lat, lng, position);
    });

    // try {
    //   country = await this.geoService.getCountryFromCoordinates(lat, lng);

    //   if (global.appClient.includes('WAGC-')) {
    //     let _subsidiaryId = '';
    //     this.mg2uUtil.getPref('subsidiaryId').subscribe(id => {
    //       _subsidiaryId = id;
    //     });
    //     console.debug(
    //       'apply subsidiary by country : ',
    //       _subsidiaryId,
    //       country,
    //       this.geoService.getCountryFromCoordinates(lat, lng)
    //     );
    //     if (_subsidiaryId === '' || _subsidiaryId === 'wagc' || _subsidiaryId === undefined) {
    //       const selectedClub = this.clubGroupList?.find(club => {
    //         return club?.country?.iso2Code === country;
    //       });
    //       this.selectedClubGroup = selectedClub;
    //       this.applySubsidiary(selectedClub?.tag).then(() => {});
    //     }
    //   }
    //   console.debug('detect country : ', country, lat, lng, position);
    // } catch (err) {
    //   console.error('Error detecting location:', err);
    //   country = 'Unknown';
    //   console.debug('detect country : ', country, lat, lng, position);
    // }
  }
  isCapacitor() {
    return this.platform.is('capacitor');
  }
  currentVersion: string;

  async setCurrentVersion() {
    this.currentVersion = await this.liveUpdate.getCurrentVersion();
  }

  onCheckUpdates() {
    this.liveUpdate.checkVersion();
  }
}
